import { useCallback, useState } from 'react'

import { useDispatch } from 'react-redux'

// UI
import { Box } from '@chakra-ui/react'
import ZZZ6DetailModal from '../components/ZZZ6DetailModal'

import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

import { useInitialTableState } from '@/components/Table/components/useInitialTableState'
import FullTable from '@/components/Table/FullTable/FullTable'
import { convertTableStateToQuery } from '@/utils/tableHelper'

import ZZZ6ListHeader from '../components/ZZZ6ListHeader'
import getZZZ6TableColumns from '../constants/zzz6TableColumns'
import useZZZ6 from '../useZZZ6'
import { LoadingSection } from '@/components/Elements'

const ZZZ6ListPage = () => {
  const title = 'ZZ6'

  // Modal State
  const [modalDetail, setModalDetail] = useState({
    show: false,
    isCreate: true,
  })

  //Table State
  const [storedTableState, setStoredTableState] = useInitialTableState(`table_state:zzz6`, {})
  const query = convertTableStateToQuery(storedTableState)

  // Hooks
  const dispatch = useDispatch()
  const { useFetchAllZZZ6s, useRemoveZZZ6, useUpdateZZZ6 } = useZZZ6()
  const { data: zzz6Response, isLoading } = useFetchAllZZZ6s(query)

  const removeZZZ6 = useRemoveZZZ6()
  const updateZZZ6 = useUpdateZZZ6()

  // Handler
  const handleAdd = () => {
    setModalDetail({
      show: true,
      isCreate: true,
      detail: {},
    })
  }

  const handleOnRowClick = (row) => {
    setModalDetail({
      show: true,
      isCreate: false,
      detail: row?.original,
    })
  }

  const handleDelete = useCallback(
    async (id) => {
      try {
        dispatch(showLoadingOverlay())

        await removeZZZ6.mutateAsync(id)

        // Jump back to first Page
      } catch (error) {
        console.log(error)
      } finally {
        dispatch(hideLoadingOverlay())
      }
    },
    [dispatch, removeZZZ6]
  )

  const handleActivate = useCallback(
    async (id) => {
      try {
        dispatch(showLoadingOverlay())
        await updateZZZ6.mutateAsync({ id, data: { isDeleted: false } })
        // Jump back to first Page
      } catch (error) {
        console.log(error)
      } finally {
        dispatch(hideLoadingOverlay())
      }
    },
    [dispatch, updateZZZ6]
  )

  const defaultColumns = getZZZ6TableColumns({
    handleActivate,
    handleDelete,
  })

  if (isLoading || !zzz6Response) {
    return <LoadingSection />
  }

  return (
    <>
      <Box h="calc(100vh - 60px)" w={'100%'}>
        <ZZZ6ListHeader title={title} handleAdd={handleAdd} query={query} />
        <Box p={5} overflowX={'auto'}>
          <FullTable
            data={zzz6Response?.data ? zzz6Response.data : []}
            rowCount={zzz6Response?.count}
            columnDef={defaultColumns}
            state={storedTableState}
            setState={setStoredTableState}
            handleRowClick={handleOnRowClick}
          />
        </Box>
      </Box>
      <ZZZ6DetailModal modalDetail={modalDetail} setModalDetail={setModalDetail} />
    </>
  )
}

export default ZZZ6ListPage
